import React, { useState, useEffect } from 'react';
import { api, adminApi } from '../../services/api';
import { useToast } from '../../hooks/use-toast';
import { Plus, Save, Trash2 } from 'lucide-react';

const ServicesManager = () => {
  const [services, setServices] = useState([]);
  const { toast } = useToast();

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    const response = await api.getServices();
    setServices(response.data);
  };

  const handleUpdate = async (id, data) => {
    try {
      await adminApi.updateService(id, data);
      toast({ title: 'Service updated!' });
      loadServices();
    } catch (error) {
      toast({ title: 'Error', variant: 'destructive' });
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-4xl font-bold text-white mb-8">Services</h1>
      <div className="grid gap-6">
        {services.map(service => (
          <div key={service.id} className="bg-gradient-to-br from-[#1a1a1b] to-[#0f0f10] rounded-xl border border-cyan-500/10 p-6">
            <input
              value={service.title}
              onChange={(e) => handleUpdate(service.id, {...service, title: e.target.value})}
              className="w-full px-4 py-2 bg-[#0a0a0b] border border-cyan-500/20 rounded-lg text-white mb-2"
            />
            <textarea
              value={service.description}
              onChange={(e) => handleUpdate(service.id, {...service, description: e.target.value})}
              className="w-full px-4 py-2 bg-[#0a0a0b] border border-cyan-500/20 rounded-lg text-white"
              rows={2}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesManager;
